import { useEffect, useState } from "react";
import { getMyAvatar } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * useAvatar — rasgos del Personaje Alpha del usuario, con caché de sesión.
 * Devuelve { features, refresh }: features es null si aún no ha creado su personaje.
 * Tras guardar en el creador se emite "alpha-avatar-updated" para refrescar
 * todas las miniaturas (navbar, mapa, comunidad...) sin recargar.
 */

let _cache = { userId: null, features: null, loaded: false };

export function notifyAvatarUpdated(features) {
  _cache = { ..._cache, features, loaded: true };
  window.dispatchEvent(new CustomEvent("alpha-avatar-updated", { detail: features }));
}

export function useAvatar() {
  const { user } = useAuth();
  const [features, setFeatures] = useState(_cache.loaded ? _cache.features : null);

  useEffect(() => {
    if (!user) {
      _cache = { userId: null, features: null, loaded: false };
      setFeatures(null);
      return;
    }
    if (_cache.loaded && _cache.userId === user.id) {
      setFeatures(_cache.features);
    } else {
      getMyAvatar()
        .then((d) => {
          _cache = { userId: user.id, features: d.features || null, loaded: true };
          setFeatures(d.features || null);
        })
        .catch(() => {});
    }
    const onUpdate = (e) => setFeatures(e.detail);
    window.addEventListener("alpha-avatar-updated", onUpdate);
    return () => window.removeEventListener("alpha-avatar-updated", onUpdate);
  }, [user]);

  return { features };
}
